Vue.component('vq-select', {
  delimiters: ['[[', ']]'],
  inject: ['$validator'],
  mixins: [eventHubMixin],
  props: {
    iconType: String,
    defaultOption: String,
    label: String,
    labelClasses: String,
    model: Object,
    name: String,
    options: Array,
    optional: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: String,
      default: 'required'
    },
    validateName: String,
    validation: {
      type: Boolean,
      default: true
    },
    tooltip: String,
    readOnly: Boolean
  },
  data: function () {
    return {
      dropdownOpen: false
    }
  },
  watch: {
    model: {
      immediate: true,
      handler() {
        if (!this.model.value) {
          this.model.label = this.defaultOption;
          this.model.value = '';
        }
        else if (!this.model.label) {
          let option = this.options.filter(el => el.value == this.model.value);
          this.model.label = option[0].label;
          this.model.value = option[0].value;
        }
        // console.log(this.model);
      }
    }
  },
  computed: {
    sync_model: {
      get() {
        return this.model
      },
      set(val) {
        this.$emit('update:model', val)
      }
    },
    sync_options() {
      return [
        {
          label: this.defaultOption,
          value: ''
        },
        ...this.options];
    },
    model_value() { return this.model.value; },
    sync_validate() {
      if (this.optional && this.validate == 'required') {
        return '';
      } else if (!this.optional && this.validate != 'required') {
        return 'required|' + this.validate;
      } else {
        return this.validate;
      }
    },
    sync_validateName() {
      if (!this.validateName && this.label) {
        return this.label;
      } else {
        return this.validateName;
      }
    },
    getIcon() {
      return this.iconType ? `${this.iconType}` : '';
    }
  },
  methods: {
    classesValidation() {
      if (this.validation && !this.readOnly) {
        return {
          'is-valid': !this.errors.has(this.name) && this.fields[this.name] && this.fields[this.name].valid && this.model.value != '',
          'is-error': this.errors.has(this.name)
        }
      }
    },
    selectOption(option) {
      this.dropdownOpen = !this.dropdownOpen;
      this.sync_model = option;
    },
    navigateList(event) {
      event.preventDefault();
      // event.detail.keyboardEvent.preventDefault();
      let previous = event.target.previousSibling;
      let next = event.target.nextSibling;
      if (event.keyCode == 38 && previous) {
        event.target.previousSibling.focus()
      }
      if (event.keyCode == 40 && next || event.keyCode == 9 && next) {
        event.target.nextSibling.focus()
      }
      if (event.keyCode == 13) {
        event.target.click()
      }
      if (event.keyCode == 27) {
        this.dropdownOpen = false;
      }
    },
    selectFocus() { 
      // this.dropdownOpen = !this.dropdownOpen;
      // document.addEventListener("click", () => {
      //   this.dropdownOpen = false;
      //   console.log('hello')
      // })
      if (this.options.length && !this.readOnly) {
        // console.log('here');
        this.$nextTick(() => {
          this.dropdownOpen = !this.dropdownOpen;
          this.$nextTick(() => {  
            let index = 0;
            if (this.model.value != '') {
              this.options.forEach((el, i) => { if (el.value == this.model.value) { index = i } })
            }
            this.$refs[this.options[index].value][0].focus()
          })
        })
      }
    }
  },
  mounted() {
    document.addEventListener("click", () => {
      this.dropdownOpen = false;
    })
    // this.eventHub.$on(`document:click`, () => {
    //   this.dropdownOpen = false;
    // })
  },
  template: `<div class="form-control" :class="[classesValidation(), {'has-validation': validation, 'is-read-only': readOnly}]">
	<!-- <label class="label pb-5" :class="labelClasses" :for="name" v-if="label">
		[[label]]
		<div class="tooltip" v-if="tooltip">
			<i class="icon icon-question-mark"></i>
			<div class="inner">
				[[tooltip]]
			</div>
		</div>
	</label> -->
	<div class="select-wrapper" :class="{ 'is-active': dropdownOpen }">
		<div class="wrapper" :class="{ 'wrapper-has-icon' : iconType }">
			<i class="form-icon" :class="getIcon" v-if="iconType"></i>
			<span class="is-optional" v-if="optional">optionnel</span>
			<select
				class="input"
				v-if="sync_options"
				v-model="sync_model"
				v-validate:model_value="sync_validate"
				:data-vv-as="sync_validateName"
				:name="name"
				:id="name"
				@click.prevent="selectFocus()"
				:disabled="readOnly">
				<option 
					v-for="(option, index) in sync_options"
					:key="index"
					:value="option"
					v-html="option.label"></option>
			</select>

			<div
				class="select-desktop"
				:id="'desktop-' + name" 
				v-if="sync_options"
				:class="{ 'is-open': dropdownOpen }">

				<button
					ref="button"
					class="toggler"
					type="button"
					@click.stop="selectFocus()"
					:disabled="readOnly">
					[[sync_model.label]]</button> 
					
				<ul v-show="dropdownOpen" @keydown="navigateList($event)">
					<li 
						v-for="(option, index) in sync_options"
						:tabIndex="index"
						:key="index"
						:ref="option.value"
						:data-value="option.label"
						@click="selectOption(option)"
						v-html="option.label">
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>`
})